import { R } from 'core/helpers'

import getNodes from './getNodes'

const hasFocusInside = (...elements) => {
  const active = document.activeElement

  if (!active) return false

  const nodes = getNodes(elements)

  return (
    R.findIndex(nodes, (node) => {
      if (!node) return false
      return node === active || node.contains?.(active)
    }) !== -1
  )
}

export default hasFocusInside
